import TextUtility from '../../../common/utility/TextUtility';
import CustomButton from '../../../common/components/CustomButton';

type KaraokeModificationFormView3CorrectionViewFieldName = 'correction';
/**
 * 確認画面
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
export default function KaraokeModificationFormView3CorrectionView({
  getValue,
  onBack,
  onNext,
} : {
  getValue: (name: KaraokeModificationFormView3CorrectionViewFieldName) => string,
  onBack: () => void,
  onNext: () => void,
}) {
  return (
    <>
      <form>
        <div className="form__body">
          <dl>
            <dt>修正理由</dt>
            <dd>Frekulの過失（提出内容と違う形で配信されている、テロップの表示タイミングに違和感がある場合など）</dd>
          </dl>
          <dl>
            <dt>修正内容</dt>
            <dd>{TextUtility.nl2br(getValue('correction'))}</dd>
          </dl>
          <dl>
            <dt>修正手数料</dt>
            <dd>なし</dd>
          </dl>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => onBack()}>戻る</CustomButton>
              <CustomButton type="default-split" onClick={() => onNext()}>修正を依頼</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </>
  );
}
